import type { ImpactBriefEstimateNotCompared } from './impact-brief-types';

/**
 * Why a site without Search Console shows no estimated traffic movement this period, said once on
 * `/review` and in the agent export (owner, 2026-11-03, TRAFFIC_ESTIMATE_CUTOVER.md D3).
 *
 * Stage 3 refuses the estimate's delta across DataForSEO's change of formula, so every page loses
 * its estimate movement. Silently, a reader sees fewer moves and no reason, and an empty list reads
 * as "nothing moved". This says what happened instead.
 *
 * Movement is promised back at the next crawl only when the newer crawl was made under the newest
 * formula (`returnsNextCrawl`); a crawl whose pages carry both formulas is not promised a return.
 */

export function estimateNotComparedSentence(notCompared: ImpactBriefEstimateNotCompared): string {
  if (notCompared.verdict === 'unknown') {
    return 'How DataForSEO estimated traffic for one of these two crawls is not recorded, so estimated traffic movement is not shown this period.';
  }
  if (notCompared.returnsNextCrawl) {
    return 'DataForSEO changed how it estimates traffic on 1 November; movement returns after the next crawl.';
  }
  return 'DataForSEO changed how it estimates traffic on 1 November, so estimated traffic movement is not shown this period.';
}

/** The line `/review` shows once above the page, or null when the estimates compare or Search Console is on. */
export function reviewPeriodEstimateNote(
  brief: { estimateNotCompared?: ImpactBriefEstimateNotCompared | null } | null | undefined
): string | null {
  const notCompared = brief?.estimateNotCompared;
  return notCompared ? estimateNotComparedSentence(notCompared) : null;
}
